import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../services/login.service';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm;
  loginResponse = '';
  loading = false;

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private sessionService: SessionService,
    private router: Router,
  ) { }

  get loginFormFields() { return this.loginForm.controls; }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  onSubmit(customerData) {
    this.loading = true;

    if (this.loginForm.invalid) {
      return;
    }

    this.loginService.login(customerData)
      .subscribe(
        user => {
          this.sessionService.setSession(user);
          this.router.navigate([`/${this.sessionService.currentUserValue.user.bo_default_url || 'businesses' }`]);
        },
        err => {
          if (!err.success) {
            this.loading = false;
            this.loginResponse = err.error.error;
          }
        });

    this.loginForm.reset();
  }
}
